import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import App from './App.jsx'
import './index.css'

// Initialise Sentry before rendering. No-ops when VITE_SENTRY_DSN is not set.
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Session replay — mask text and block media to avoid leaking PII.
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Capture 10 % of transactions for performance tracing.
    tracesSampleRate: 0.1,
    // Capture 10 % of sessions for replay; 100 % when an error occurs.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Never send tokens, keys, or auth headers.
    sendDefaultPii: false,
    beforeSend(event) {
      // Strip Authorization headers from breadcrumbs/request context.
      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
        delete event.request.headers['X-API-Key'];
      }
      return event;
    },
  });
}

// Initialise PostHog before rendering. No-ops when VITE_POSTHOG_KEY is not set.
if (import.meta.env.VITE_POSTHOG_KEY) {
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: 'https://eu.i.posthog.com',
    capture_pageview: true,
    autocapture: false,
    persistence: 'localStorage',
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
